module.exports = "/assets/ff145e80094a2daf54069e76e2dfdcd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/NF.png
// module id = 2769
// module chunks = 0